import { NavigationGuardNext, RouteLocationNormalizedGeneric, RouteLocationNormalizedLoadedGeneric } from "vue-router";
import { useUserAuthenticatedStore } from "../../components/AuthComponent/stores/UserAuthenticated.store";
import { useOrderStore } from "../../components/TableArticules/store/Order.store";
import { useOrderDetail } from "../../components/OrderShipmentData/store/OrderShipmentData.store";




const isAuthenticatedGuard = async(
    _to:RouteLocationNormalizedGeneric, 
    _from:RouteLocationNormalizedLoadedGeneric, 
    next:NavigationGuardNext
) => {

    const userStore = useUserAuthenticatedStore();
    const orderArticles = useOrderStore()
    const orderDetails = useOrderDetail()

    try {
        
        await userStore.initializeUserStore();

        
        
        if(!userStore.checkUserAuth) {
            orderArticles.clearArticlesOrder()
            orderDetails.resetOrderDetails()
            return next({
                name: 'home'
            })
        }
        
        
    
        return next()

    } catch (error) {
        console.error('Error de autenticacion: ', error)
        return next({
            name: 'home'
        })
    }


}



export default isAuthenticatedGuard;
